import * as PIXI from "pixi.js";
import Main from "../Main";
import UILayer from "../layers/UILayer";
import TextureManager from "../managers/TextureManager";
import { EnumEventBus, EventBus } from "../managers/EventBus";
import WFireworkAnimation from "../animations/WFireworkAnimation";
import { ButtonBounds } from "../types/Interface";
import StarAnimation from "../animations/StarAnimation";
import { fireworkObject, INITIAL_FRAME_COLOR, INITIAL_FRAME_TYPE } from "../types/Config";
import { FireworksColor, FireworksType } from "../types/Enum";
import FrameAnimation from "../animations/FrameAnimation";


const WFireworkBG = "./images/scene/one-fire-box.png";
const STAR = "./images/winning_icons/prize_star.png";


export default class WinningFirework extends PIXI.Container {
  Main = Main.getInstance();
  UILayer = UILayer.getInstance();
  EventBus = EventBus;
  Bounds: ButtonBounds;
  WFireworkCon: PIXI.Container;
  WFirework: PIXI.Sprite;
  fire: PIXI.Sprite;
  index: number = -1;
  starCon: StarCon;
  frame: PIXI.Sprite;
  typeFrame: PIXI.Sprite;
  currColor = INITIAL_FRAME_COLOR;
  currType = INITIAL_FRAME_TYPE;

  constructor(Bounds: ButtonBounds) {
    super();
    this.Bounds = Bounds;
    this.starCon = new StarCon(this.Bounds.width / 2 + 30);
    this.addChild(this.starCon);
    this.addCoords();
    this.addBg();
    this.addFrame();
    this.addTypeFrame();
    this.addWFireworkCon();
    this.addFire();
    this.addWinningFirework();

    this.UILayer.addChild(this);
    this.EventBus.on(EnumEventBus.setBonusGame, (status: boolean) => this.setStarCon(Boolean(status)))
    this.EventBus.on(EnumEventBus.updateWFireworkTexture, (index: number) => {
      this.updateFrame(index);
      this.updateTexture(index);
    })
  }

  getFrameTexture = (name: FireworksColor | FireworksType) => name == FireworksType.full
    ? new PIXI.Texture(PIXI.Texture.EMPTY)
    : TextureManager.getTexture(`./images/scene/b1_${name}.png`);
  generateFireworkPath = (x: number) => `./images/fireworks/firework-${x}.png`;
  setStarCon(status: boolean) {
    if (status) {
      return this.starCon.show();
    }
    this.starCon.hide();
  }
  addCoords() {
    this.x = this.Bounds.x;
    this.y = this.Bounds.y;
  }
  addWFireworkCon() {
    this.WFireworkCon = new PIXI.Container();
    this.addChild(this.WFireworkCon);
  }
  addWinningFirework() {
    const texture = new PIXI.Texture(PIXI.Texture.EMPTY);
    this.WFirework = new PIXI.Sprite(texture);
    this.WFirework.width = this.Bounds.width * .85;
    this.WFirework.height = this.Bounds.height * .85;
    this.WFirework.y = 0;
    this.WFirework.anchor.set(.5);
    this.WFireworkCon.addChild(this.WFirework);
  }
  addFire() {
    const texture = TextureManager.getTexture(`./images/fireworks/fire.png`);
    this.fire = new PIXI.Sprite(texture);
    this.fire.y = 50
    this.fire.anchor.set(.5, .1);
    this.fire.scale.set(.2);
    this.fire.visible = false;
    this.WFireworkCon.addChild(this.fire);
  }
  addBg() {
    const texture = TextureManager.getTexture(WFireworkBG);
    const bg = new PIXI.Sprite(texture);
    bg.anchor.set(.5);
    bg.width = this.Bounds.width - 25;
    bg.height = this.Bounds.height - 25;
    this.addChild(bg);
  }
  generateFrame(name: FireworksColor | FireworksType) {
    const texture = this.getFrameTexture(name)
    const frame = new PIXI.Sprite(texture);
    frame.anchor.set(.5);
    frame.width = this.Bounds.width;
    frame.height = this.Bounds.height;
    return frame;
  }
  addFrame() {
    this.frame = this.generateFrame(this.currColor);
    this.addChild(this.frame);
  }
  addTypeFrame() {
    this.typeFrame = this.generateFrame(this.currType);
    this.typeFrame.height *= .5615;
    this.typeFrame.anchor.set(.5, .43)
    this.addChild(this.typeFrame);
  }
  updateFrame(index: number) {
    const firework = fireworkObject[index];
    if (firework.color == this.currColor && firework.type == this.currType) {
      return
    }
    new FrameAnimation(this.frame, .3, 200, () => {
      this.frame.texture = this.getFrameTexture(firework.color);
      this.typeFrame.texture = this.getFrameTexture(firework.type);
      new FrameAnimation(this.frame, 1, 200, () => {
        this.currColor = firework.color;
        this.currType = firework.type;
      });
    })
  }
  updateTexture(index) {
    this.index = index;
    const path = this.generateFireworkPath(this.index);
    const texture = TextureManager.getTexture(path);
    this.WFireworkCon.y = this.Main.getDim().height + 93;
    this.WFirework.texture = texture;
    this.fire.visible = true;
    new WFireworkAnimation(this.WFireworkCon, 0, () => {
      this.fire.visible = false;
    });
  }
}


class StarCon extends PIXI.Container {
  private distance: number;
  constructor(distance: number) {
    super();
    this.distance = distance;
    this.visible = false;
    this.add();
  }
  addStar(bounds: { x: number, y: number, width: number, height: number, rotation: number }) {
    const starTexture = TextureManager.getTexture(STAR);
    const star = new PIXI.Sprite(starTexture);
    star.anchor.set(.5);
    Object.assign(star, bounds);
    new StarAnimation(star, { width: bounds.width * 1.2, height: bounds.height * 1.2 });
    this.addChild(star);
  }
  hide() {
    this.visible = false;
  }
  show() {
    this.visible = true;
  }
  add() {
    this.addStar({ x: Math.cos(-Math.PI / 2) * this.distance, y: Math.sin(-Math.PI / 2) * this.distance, width: 50, height: 50, rotation: 0 });
    this.addStar({ x: Math.cos(-(Math.PI * (3.5 / 5))) * this.distance, y: Math.sin(-(Math.PI * (3.5 / 5))) * this.distance, width: 50, height: 50, rotation: -Math.PI / 5 });
    this.addStar({ x: Math.cos(-(Math.PI * (1.5 / 5))) * this.distance, y: Math.sin(-(Math.PI * (1.5 / 5))) * this.distance, width: 50, height: 50, rotation: Math.PI / 5 });
  }
}